import React from 'react'
import Panel from 'muicss/lib/react/panel'
import Container from 'muicss/lib/react/container'
import Col from 'muicss/lib/react/col'
import RaisedButton from 'material-ui/RaisedButton'
import Form from 'muicss/lib/react/form'
import { TextField } from 'redux-form-material-ui'
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import { recovery_password } from '../../actions'

class RecoveryPassword extends React.Component {

  render() {
    return (
      <Container>
        <Col xs={12} md-offset={3} md={6} >
          <Panel className="modal-panel">
            <Form onSubmit={this.props.handleSubmit(this.props.recovery_password)}>
              <legend>Recuperar Contraseña</legend>
              <Field name="email" label="Email" component={TextField} fullWidth floatingLabelText="Email" type="email" />
              <br />
              <br />
              <div style={{ textAlign: 'center' }}>
                <RaisedButton type="submit" label="Enviar Correo" primary style={{ textAlign: 'center' }} />
              </div>
            </Form>
          </Panel>
        </Col>
      </Container>
    )
  }
}

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  recovery_password: values => dispatch(recovery_password(values)),
})

const Redux = connect(mapStateToProps, mapDispatchToProps)(RecoveryPassword)

export default reduxForm({
  form: 'RecoveryPasswordForm',
})(Redux)




// WEBPACK FOOTER //
// ./src/components/RecoveryPassword/index.jsx